import './css/ErrorPage.css';

const errorContent = {
  403: {
    eyebrow: 'Access denied',
    title: 'This page is off limits.',
    message: 'You do not have permission to view the page you requested.',
  },
  404: {
    eyebrow: 'Page not found',
    title: 'That step is not in the routine.',
    message: 'The page may have moved, or the address may be incorrect.',
  },
  500: {
    eyebrow: 'Server error',
    title: 'We missed a step.',
    message: 'Something unexpected happened. Please refresh the page or try again shortly.',
  },
  503: {
    eyebrow: 'Temporarily unavailable',
    title: 'We will be back on the floor soon.',
    message: 'The website is briefly unavailable while we make an update.',
  },
};

export default function ErrorPage({ statusCode = 404 }) {
  const error = errorContent[statusCode] || errorContent[500];

  return (
    <main className="error-page">
      <section className="error-card" aria-labelledby="error-title">
        <p className="error-code" aria-hidden="true">{statusCode}</p>
        <p className="error-eyebrow">{error.eyebrow}</p>
        <h1 id="error-title">{error.title}</h1>
        <p className="error-message">{error.message}</p>
        <div className="error-actions">
          <a className="error-primary-action" href="/home">Return home</a>
          <a className="error-secondary-action" href="/contact">Contact us</a>
        </div>
      </section>
    </main>
  );
}
